
import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'FrontPageAds',
  components: {},
  data() {
    return {
      frontPageAds: [],
    }
  },
  props: {},
  methods: {
    getFrontPageAds() {
      this.$store.dispatch('jobs/getFrontPageAds').then((response: any) => {
        this.frontPageAds = response.documents;
      })
    },
  },
  mounted() {
    this.getFrontPageAds()
  },
  computed: {
    primaryColor() {
      return this.$store.state.client.design.primaryColor
    },
    secondaryColor() {
      return this.$store.state.client.design.secondaryColor
    },
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b63c8310": (_ctx.primaryColor),
  "681cdef4": (_ctx.secondaryColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__